import { render, staticRenderFns } from "./displayInfoItem.vue?vue&type=template&id=0e37a10f&scoped=true"
import script from "./displayInfoItem.vue?vue&type=script&lang=js"
export * from "./displayInfoItem.vue?vue&type=script&lang=js"
import style0 from "./displayInfoItem.vue?vue&type=style&index=0&id=0e37a10f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e37a10f",
  null
  
)

export default component.exports